import request from '@/utils/request'

export function queryLatestData(devid) {
  return request({
    url: `/state/${devid}`,
    method: 'get'
  })
}
